import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function DownloadAttachmentsOverlay({
  downloadWithAttachments,
  downloadWithoutAttachments,
  ...overlay
}) {
  const { t } = useTranslation()

  return (
    <DialogOverlay title={`${t('chat.attachmentsFound', 'Attachments Found')}`} {...overlay}>
      <Paragraph size="sm">
        {t(
          'chat.conversationHasAttachments',
          'This chat conversation contains images and/or attachments. Would you like to download them?'
        )}
      </Paragraph>
      <DialogOverlayActions>
        <Button onClick={downloadWithAttachments} emphasis="medium">
          {t('chat.withAttachments', 'With attachments')}
        </Button>
        <Button onClick={downloadWithoutAttachments} emphasis="medium">
          {t('chat.onlyText', 'Only Text')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
